export const INCIDENT_LIST = 'INCIDENT_LIST';
export const INCIDENT_LIST_SUCCESS = 'INCIDENT_LIST_SUCCESS';
export const INCIDENT_LIST_ERROR = 'INCIDENT_LIST_ERROR';
export const INCIDENT_LIST_DETAILS = 'INCIDENT_LIST_DETAILS';
export const INCIDENT_LIST_DETAILS_ERROR = 'INCIDENT_LIST_DETAILS_ERROR';
export const INCIDENT_LIST_DETAILS_SUCCESS = 'INCIDENT_LIST_DETAILS_SUCCESS';

export const USERS_LIST = 'USERS_LIST';
export const USERS_LIST_SUCCESS = 'USERS_LIST_SUCCESS';
export const USERS_LIST_ERROR = 'USERS_LIST_ERROR';